import { IMAGE_PROVIDER_TYPES } from 'js/config/consts';
import { rateLimitedfetch } from 'js/shared/helpers/rateLimitedFetch';
import { getProviderForType } from 'js/shared/providers';

export default async function getImageFileFromProvider(provider, imageId) {
  const providerFn = getProviderForType(provider);
  if (provider === IMAGE_PROVIDER_TYPES.STREAMLINE) {
    // for streamline, the provider function returns the svg content, not a url
    const svgContent = await providerFn(imageId);
    return new Blob([svgContent], { type: 'image/svg+xml' });
  }
  const url = await providerFn(imageId);
  const resp = await rateLimitedfetch(url);
  const originalFile = await resp.blob();
  return originalFile;
}
